import { render, staticRenderFns } from "./LanguageSelectorItem.vue?vue&type=template&id=1278c9a6&scoped=true&"
import script from "./LanguageSelectorItem.vue?vue&type=script&lang=js&"
export * from "./LanguageSelectorItem.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSelectorItem.vue?vue&type=style&index=0&id=1278c9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1278c9a6",
  null
  
)

export default component.exports